import { useLocation } from 'react-router';
import React, { useMemo, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { MOBILE_SLIDER_PAGES_IDS } from './mobileSliderPagesConstants';
import appHistory from '../../../app/appHistory';
import useEffectOnce from '../../../hooks/useEffectOnce';
import SlideMobileAccountStatLoadable from './slides/SlideMobileAccountStat/SlideMobileAccountStatLoadable';
import SlideMobileAssetInfoLoadable from './slides/SlideMobileAssetInfo/SlideMobileAssetInfoLoadable';
import SlideMobileCollectionLoadable from './slides/SlideMobileCollection/SlideMobileCollectionLoadable';
import SlideMobileDepositLoadable from './slides/SlideMobileDeposit/SlideMobileDepositLoadable';
import SlideMobileDepositSurveyLoadable from './slides/SlideMobileDepositSurvey/SlideMobileDepositSurveyLoadable';
import SlideMobileAssetChartLoadable from './slides/SlideMobileAssetChart/SlideMobileAssetChartLoadable';
import SlideMobileEmailConfirmedLoadable from './slides/SlideMobileEmailConfirmed/SlideMobileEmailConfirmedLoadable';
import SlideMobilePositionUpdateLoadable from './slides/SlideMobilePositionUpdate/SlideMobilePositionUpdateLoadable';
import SlideMobilePositionCreateLoadable from './slides/SlideMobilePositionCreate/SlideMobilePositionCreateLoadable';
import SlideMobileHistoryLoadable from './slides/SlideMobileHistory/SlideMobileHistoryLoadable';
import SlideMobileSettingsLoadable from './slides/SlideMobileSettings/SlideMobileSettingsLoadable';
import SlideMobileHistoryInfoLoadable from './slides/SlideMobileHistoryInfo/SlideMobileHistoryInfoLoadable';
import SlideMobileVerifyLoadable from './slides/SlideMobileVerify/SlideMobileVerifyLoadable';
import SlideMobileWithdrawLoadable from './slides/SlideMobileWithdraw/SlideMobileWithdrawLoadable';
import SlideMobilePromocodeHelloJetvix from './slides/SlideMobilePromocodeHelloJetvix';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import SlideMobileCommunity from './slides/SlideMobileCommunity/SlideMobileCommunity';
import SlideMobileWithdrawalCancelLoadable
    from './slides/SlideMobileWithdrawalCancel/SlideMobileWithdrawalCancelLoadable';
import { OffcanvasPlacement } from 'react-bootstrap/Offcanvas';
import SlideMobileGloryArenaLoadable from './slides/SlideMobileGloryArena/SlideMobileGloryArenaLoadable';
import SlideMobileGotAchievementLoadable from './slides/SlideMobileGotAchievement/SlideMobileGotAchievementLoadable';
import SlideMobileRequestFeedback from './slides/SlideMobileRequestFeedback/SlideMobileRequestFeedback';
import SlideMobileRefillDemoLoadable from './slides/SlideMobileRefillDemo/SlideMobileRefillDemoLoadable';
import SlideMobileRespawnRealLoadable from './slides/SlideMobileRespawnReal/SlideMobileRespawnRealLoadable';
import SlideMobileUpdatePositionLoadable from './slides/SlideMobileUpdatePosition/SlideMobileUpdatePositionLoadable';
import SlideMobileUpdateOrderLoadable from './slides/SlideMobileUpdateOrder/SlideMobileUpdateOrderLoadable';
import SlideMobileTutorialVideoLoadable from './slides/SlideMobileTutorialVideo/SlideMobileTutorialVideoLoadable';
import SlideMobileTutorialsLoadable from './slides/SlideMobileTutorials/SlideMobileTutorialsLoadable';
import SlideMobileUserStatusesLoadable from './slides/SlideMobileUserStatuses/SlideMobileUserStatusesLoadable';
import SlideDeleteProfile from './slides/SlideDeleteProfile/SlideDeleteProfile';
import SlideMobileVerifySumsubLoadable from './slides/SlideMobileVerifySumsub/SlideMobileVerifySumsubLoadable';
import SlideMobileVerifyManualLoadable from './slides/SlideMobileVerifyManual/SlideMobileVerifyManualLoadable';
import SlideMobileGotStatusLoadable from './slides/SlideMobileGotStatus/SlideMobileGotStatusLoadable';
import { LOCATION_COMPONENTS_SEARCH_PARAMS } from '../../../modules/Location/locationConstants';
import SlideMobileAlertsLoadable from './slides/SlideMobileAlerts/SlideMobileAlertsLoadable';
import SlideMobileWithdrawalLimitsLoadable
    from './slides/SlideMobileWIthdrawalLimits/SlideMobileWithdrawalLimitsLoadable';
import SlideMobileUserStateInformationLoadable
    from './slides/SlideMobileUserStateInformation/SlideMobileUserStateInformationLoadable';
import { FEATURES } from '../../../app/appConstants';
import { useSelector } from 'react-redux';
import { getAppFeatures } from '../../../app/appSelectors';
import { ValueOf } from '../../../types';
import SlideMobileClientAgreementLoadable from './slides/SlideMobileClientAgreement/SlideMobileClientAgreementLoadable';
import SlideMobilePrivacyPolicyLoadable from './slides/SlideMobilePrivacyPolicy/SlideMobilePrivacyPolicyLoadable';
import SlideMobileRespawnMotivationLoadable
    from './slides/SlideMobileRespawnMotivationLoadable/SlideMobileRespawnMotivationLoadable';
import SlideMobileBeginnersGuide from './slides/SlideMobileBeginnersGuide/SlideMobileBeginnersGuide';
import SlideMobileAdvancedSettingsLoadable
    from './slides/SlideMobileAdvancedSettings/SlideMobileAdvancedSettingsLoadable';
import SlideMobileAppearanceLoadable from './slides/SlideMobileAppearance/SlideMobileAppearanceLoadable';
import SlideMobileReferralsLoadable from './slides/SlideMobileReferrals/SlideMobileReferralsLoadable';
import SlideMobileReferralRulesLoadable from './slides/SlideMobileReferralRules/SlideMobileReferralRulesLoadable';
import DemoLimitsSlideLoadable from '../../../modules/DemoLimits/components/DemoLimitsSlide/DemoLimitsSlideLoadable';
import SlideMobileReferralReceivedRewardLoadable
    from './slides/SlideMobileReferralReceivedReward/SlideMobileReferralReceivedRewardLoadable';
import SlideVerifyRequestLoadable from './slides/SlideVerifyRequest/SlideVerifyRequestLoadable';
import SlideMobileReferralGiftLoadable from './slides/SlideMobileReferralGift/SlideMobileReferralGiftLoadable';
import SlideMobileReferralWarningResetProgressLoadable
    from './slides/SlideMobileReferralWarningResetProgress/SlideMobileReferralWarningResetProgressLoadable';
import SlideMobileReferralSharedLinkLoadable
    from './slides/SlideMobileReferralSharedLink/SlideMobileReferralSharedLinkLoadable';
import SlideMobileReferralSharedQrCodeLoadable
    from './slides/SlideMobileReferralSharedQrCode/SlideMobileReferralSharedQrCodeLoadable';
import SlideMobileReferralRespawnTimerLoadable
    from './slides/SlideMobileReferralRespawnTimer/SlideMobileReferralRespawnTimerLoadable';
import SlideMobileAcademyCourseLoadable from './slides/SlideMobileAcademyCourse/SlideMobileAcademyCourseLoadable';
import SlideMobileAcademyLessonLoadable from './slides/SlideMobileAcademyLesson/SlideMobileAcademyLessonLoadable';
import SlideMobileLeaderboardNotificationMessageLeagueLoadable
    from './slides/SlideMobileLeaderboardNotificationMessageLeague/SlideMobileLeaderboardNotificationMessageLeagueLoadable';

interface IMobileSliderPrivatePagesComponents {
    [key: string]: {
        component: any;
        params: {
            backdrop?: boolean,
            popUpClassName?: string,
            placement?: OffcanvasPlacement,
            style?: any,
            disabledByFeatures?: Array<ValueOf<typeof FEATURES>>,
            enabledByFeatures?: Array<ValueOf<typeof FEATURES>>,
        };
    };
}

const MOBILE_SLIDER_PRIVATE_PAGES_COMPONENTS: IMobileSliderPrivatePagesComponents = {
    [MOBILE_SLIDER_PAGES_IDS.ACCOUNT_STAT]: { component: SlideMobileAccountStatLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.ASSET]: { component: SlideMobileAssetInfoLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.ALERTS]: { component: SlideMobileAlertsLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.COLLECTION]: { component: SlideMobileCollectionLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.COMMUNITY]: { component: SlideMobileCommunity, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.DEPOSIT]: {
        component: SlideMobileDepositLoadable,
        params: { disabledByFeatures: [FEATURES.DEMO_MODE] },
    },
    [MOBILE_SLIDER_PAGES_IDS.DEPOSIT_SURVEY]: { component: SlideMobileDepositSurveyLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.GRAPH]: { component: SlideMobileAssetChartLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.EMAIL_CONFIRMED]: { component: SlideMobileEmailConfirmedLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.POSITION_UPDATE]: { component: SlideMobilePositionUpdateLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.POSITION_CREATE]: { component: SlideMobilePositionCreateLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.PROMOCODE_HELLO_JETVIX]: { component: SlideMobilePromocodeHelloJetvix, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.TUTORIAL_VIDEO]: { component: SlideMobileTutorialVideoLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.TUTORIALS]: { component: SlideMobileTutorialsLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.RESPAWN]: { component: SlideMobileRespawnRealLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.SETTINGS]: { component: SlideMobileSettingsLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.ADVANCED_SETTINGS]: { component: SlideMobileAdvancedSettingsLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.HISTORY]: { component: SlideMobileHistoryLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO]: { component: SlideMobileHistoryInfoLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.ORDER_UPDATE_2]: {
        component: SlideMobileUpdateOrderLoadable,
        params: {
            popUpClassName: "px-0",
            placement: 'bottom',
            backdrop: false,
            style: {
                backgroundColor: 'var(--color-background-secondary-to-primary)',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.POSITION_UPDATE_2]: {
        component: SlideMobileUpdatePositionLoadable,
        params: {
            popUpClassName: "px-0",
            placement: 'bottom',
            backdrop: false,
            style: {
                backgroundColor: 'var(--color-background-secondary-to-primary)',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.VERIFY]: { component: SlideMobileVerifyLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.VERIFY_MANUAL]: { component: SlideMobileVerifyManualLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.VERIFY_SUMSUB]: { component: SlideMobileVerifySumsubLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.VERIFY_REQUEST]: {
        component: SlideVerifyRequestLoadable, params: {
            placement: 'bottom',
            popUpClassName: 'action-sheet',
            style: {
                padding: '0',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_CANCEL]: {
        component: SlideMobileWithdrawalCancelLoadable,
        params: {
            placement: 'bottom',
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.WITHDRAW]: {
        component: SlideMobileWithdrawLoadable,
        params: { disabledByFeatures: [FEATURES.DEMO_MODE] },
    },
    [MOBILE_SLIDER_PAGES_IDS.WITHDRAWAL_LIMITS]: { component: SlideMobileWithdrawalLimitsLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.GLORY_ARENA]: { component: SlideMobileGloryArenaLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.ACHIEVEMENT]: {
        component: SlideMobileGotAchievementLoadable,
        params: { style: { background: 'transparent' }, backdrop: false },
    },
    [MOBILE_SLIDER_PAGES_IDS.USER_STATUS_CONGRATULATIONS]: {
        component: SlideMobileGotStatusLoadable,
        params: { style: { background: 'transparent' }, backdrop: false },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFILL]: { component: SlideMobileRefillDemoLoadable, params: {} },
    [MOBILE_SLIDER_PAGES_IDS.REQUEST_FEEDBACK]: {
        component: SlideMobileRequestFeedback,
        params: {
            placement: 'bottom',
            popUpClassName: 'action-sheet',
            style: {
                padding: '0',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.USER_STATUSES]: {
        component: SlideMobileUserStatusesLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.DELETE_PROFILE]: {
        component: SlideDeleteProfile,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.USER_STATE_INFORMATION]: {
        component: SlideMobileUserStateInformationLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.RESPAWN_MOTIVATION]: {
        component: SlideMobileRespawnMotivationLoadable,
        params: { style: { background: 'transparent' } },
    },
    [MOBILE_SLIDER_PAGES_IDS.BEGINNERS_GUIDE]: {
        component: SlideMobileBeginnersGuide,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.CLIENT_AGREEMENT]: {
        component: SlideMobileClientAgreementLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.PRIVACY_POLICY]: {
        component: SlideMobilePrivacyPolicyLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL]: {
        component: SlideMobileReferralsLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_RULES]: {
        component: SlideMobileReferralRulesLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.APPEARANCE]: {
        component: SlideMobileAppearanceLoadable,
        params: {
            enabledByFeatures: [FEATURES.COLOR_THEME],
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_RECEIVED_REWARD]: {
        component: SlideMobileReferralReceivedRewardLoadable,
        params: { style: { background: 'transparent' } },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_GIFT_REWARD]: {
        component: SlideMobileReferralGiftLoadable, params: {
            placement: 'bottom',
            popUpClassName: 'action-sheet',
            style: {
                padding: '0',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.LEADERBOARD_NOTIFICATION_LEAGUE]: {
        component: SlideMobileLeaderboardNotificationMessageLeagueLoadable,
        params: {
            placement: 'bottom',
            popUpClassName: 'action-sheet',
            style: {
                padding: '0',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.DEMO_LIMITS]: {
        component: DemoLimitsSlideLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_WARNING_RESET_PROGRESS]: {
        component: SlideMobileReferralWarningResetProgressLoadable, params: {
            placement: 'bottom',
            popUpClassName: 'action-sheet',
            style: {
                padding: '0',
            },
        },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_SHARE_LINK]: {
        component: SlideMobileReferralSharedLinkLoadable,
        params: { style: { background: 'transparent' }, backdrop: false },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_SHARE_QR_CODE]: {
        component: SlideMobileReferralSharedQrCodeLoadable,
        params: { style: { background: 'transparent' }, backdrop: false },
    },
    [MOBILE_SLIDER_PAGES_IDS.REFERRAL_RESPAWN_TIMER]: {
        component: SlideMobileReferralRespawnTimerLoadable,
        params: { style: { background: 'transparent' }, backdrop: false },
    },
    [MOBILE_SLIDER_PAGES_IDS.ACADEMY_COURSE]: {
        component: SlideMobileAcademyCourseLoadable,
        params: {},
    },
    [MOBILE_SLIDER_PAGES_IDS.ACADEMY_LESSON]: {
        component: SlideMobileAcademyLessonLoadable,
        params: {},
    },
};

const mobileSliderPrivatePagesComponentsList = Object.entries(MOBILE_SLIDER_PRIVATE_PAGES_COMPONENTS);

const NAVIGATION_TYPES = { FIRST_PAGE: 'first_page', NEXT_PAGE: 'next_page' } as const;
type TNavigation = typeof NAVIGATION_TYPES[keyof typeof NAVIGATION_TYPES]

function MobileSliderPrivatePages() {
    const [navigationType, setNavigationType] = useState<TNavigation>(NAVIGATION_TYPES.FIRST_PAGE);
    const { pathname, search } = useLocation();
    const features = useSelector(getAppFeatures);

    const openedPageIds = useMemo(() => {
        const params = new URLSearchParams(search);
        return params.getAll(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE);
    }, [search]);

    useUpdateEffect(() => {
        if (navigationType === NAVIGATION_TYPES.FIRST_PAGE) {
            setNavigationType(NAVIGATION_TYPES.NEXT_PAGE);
        }
    }, [search]);

    // добавляем возможность закрыть слайд по кнопке назад если зашли на него по ссылке
    useEffectOnce(() => {
        if (openedPageIds.length > 0) {
            appHistory.replace({ pathname });
            appHistory.push(`${pathname}${search}`);
        }
    });

    return <>
        {
            mobileSliderPrivatePagesComponentsList.map(([pageId, item], index) => {
                const Component = item.component;
                if (item.params?.enabledByFeatures?.some(feature => !features[feature])) return null;
                if (item.params?.disabledByFeatures?.some(feature => !!features[feature])) return null;
                return <Offcanvas
                    onHide={() => {
                        appHistory.goBack();
                    }}
                    className={item.params?.popUpClassName}
                    key={pageId}
                    data-page-id={pageId}
                    show={openedPageIds.includes(pageId)}
                    placement={item.params?.placement || 'end'}
                    style={{
                        top: (!item.params?.placement || item.params.placement === 'end') ? '-1px' : null,
                        width: '100%',
                        // zIndex: 1050 + index,
                        transition: navigationType === NAVIGATION_TYPES.FIRST_PAGE ? 'none' : undefined,
                        ...(item.params?.style || {}),
                    }}
                    backdrop={item.params?.backdrop === false ? false : undefined}
                >
                    <Component/>
                </Offcanvas>;
            })
        }
    </>;
}

export default MobileSliderPrivatePages;
